export const NO_PROJECT_LABEL = "No Project";
